import { Switch, ThemePicker } from "@jkast90/kast-common/ui";
import { useAdminMode } from "../adminMode";
import { themeStore } from "../theme";

/** The site's own settings, on About and in Profile's Settings; the player's are in its Settings drawer. */
export default function Preferences() {
  const adminMode = useAdminMode();
  return (
    <>
      <div className="field">
        <span className="field-label">Theme</span>
        <div className="field-control">
          <ThemePicker store={themeStore} label="Theme" />
          <span className="muted small">Follows your account when you're signed in.</span>
        </div>
      </div>
      {adminMode.isAdmin && (
        <div className="field">
          <span className="field-label">Admin</span>
          <div className="field-control">
            <Switch
              size="sm"
              wrapperClassName="controls-switch"
              label="Admin tools (the Admin page, and admin actions elsewhere), on this device"
              checked={adminMode.unlocked}
              onChange={adminMode.setEnabled}
            />
          </div>
        </div>
      )}
    </>
  );
}
